import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import { BarChart3, Users, Hash, ShieldAlert, ArrowLeft, Smile, Boxes, Store, Sticker, Music, Wallet } from 'lucide-react';
import AdminStats from './AdminStats';
import AdminUsers from './AdminUsers';
import AdminChannels from './AdminChannels';
import AdminModlog from './AdminModlog';
import AdminReactions from './AdminReactions';
import AdminWorkspaces from './AdminWorkspaces';
import AdminWorkspaceDetail from './AdminWorkspaceDetail';
import AdminShop from './AdminShop';
import AdminBilling from './AdminBilling';
import AdminStickers from './AdminStickers';
import AdminMusic from './AdminMusic';
import clsx from 'clsx';

const navItems = [
  { path: '/admin', label: 'Overview', icon: BarChart3, exact: true },
  { path: '/admin/users', label: 'Users', icon: Users },
  { path: '/admin/channels', label: 'Channels', icon: Hash },
  { path: '/admin/workspaces', label: 'Workspaces', icon: Boxes },
  { path: '/admin/shop', label: 'Shop', icon: Store },
  { path: '/admin/billing', label: 'Billing', icon: Wallet },
  { path: '/admin/stickers', label: 'Stickers', icon: Sticker },
  { path: '/admin/music', label: 'Music', icon: Music },
  { path: '/admin/reactions', label: 'Reactions', icon: Smile },
  { path: '/admin/modlog', label: 'Mod Log', icon: ShieldAlert },
];

export default function AdminPage() {
  const location = useLocation();

  return (
    <div className="flex h-screen bg-surface-950 overflow-hidden">
      {/* Sidebar */}
      <aside className="w-56 bg-surface-900 border-r border-surface-800 flex flex-col flex-shrink-0">
        <div className="h-12 px-4 flex items-center gap-2 border-b border-surface-800">
          <ShieldAlert size={16} className="text-brand-400" />
          <span className="font-bold text-surface-50 text-sm">Admin Panel</span>
        </div>

        <nav className="flex-1 py-3 space-y-0.5 px-2">
          {navItems.map(({ path, label, icon: Icon, exact }) => {
            const active = exact
              ? location.pathname === path
              : location.pathname.startsWith(path) && path !== '/admin';
            const isExactActive = location.pathname === '/admin' && exact;
            return (
              <Link
                key={path}
                to={path}
                className={clsx(
                  'sidebar-item',
                  (active || isExactActive) && 'sidebar-item-active',
                )}
              >
                <Icon size={15} />
                {label}
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-surface-800">
          <Link to="/chat" className="sidebar-item w-full">
            <ArrowLeft size={14} />
            Back to Chat
          </Link>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 overflow-y-auto">
        <Routes>
          <Route index element={<AdminStats />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="channels" element={<AdminChannels />} />
          <Route path="workspaces" element={<AdminWorkspaces />} />
          <Route path="workspaces/:slug" element={<AdminWorkspaceDetail />} />
          <Route path="shop" element={<AdminShop />} />
          <Route path="billing" element={<AdminBilling />} />
          <Route path="stickers" element={<AdminStickers />} />
          <Route path="music" element={<AdminMusic />} />
          <Route path="reactions" element={<AdminReactions />} />
          <Route path="modlog" element={<AdminModlog />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}
